<template>
  <!-- eslint-disable vue/no-template-shadow -->
  <div class="page--brands">
    <div class="container">
      <div class="row brand-list">
        <div class="col-sm-12">
          <h4 class="page-heading">Brands</h4>
        </div>
        <div class="col-sm-9">
          <div class="brand-content">
            <div class="menu-bar">
              <div class="search">
                <input
                  v-model="keyword"
                  type="text"
                  name="search"
                  autocomplete="off"
                  placeholder="Search Brand..."
                  class="input-search"
                  @keyup="searchQuery"
                />
                <span class="icon-search"></span>
              </div>
              <div class="search-by-alpha">
                <template v-for="(value, key) in allBrand">
                  <router-link
                    v-if="key === '#'"
                    :key="key"
                    :to="`/brands/${'1'}/`"
                    :class="{ active: selectedLetter === key }"
                    class="brand-tag"
                    >{{ key }}</router-link
                  >
                  <router-link
                    v-else
                    :key="key"
                    :to="`/brands/${key.toLowerCase()}/`"
                    :class="{ active: selectedLetter === key }"
                    class="brand-tag"
                    >{{ key }}</router-link
                  >
                </template>
              </div>
            </div>
            <div class="content-page-brand">
              <div v-if="isFinishLoadingAllBrand">
                <!-- eslint-disable vue/no-use-v-if-with-v-for -->
                <div v-for="(value, key) in allBrand" v-if="value.length" :key="key" class="list-letter-brand">
                  <h4 :id="'brand-letter-' + key" class="brand-letter">
                    {{ key }}
                  </h4>

                  <router-link v-if="key === '#'" :to="`/brands/${'1'}`" class="show-all"> See all> </router-link>
                  <router-link v-else :to="`/brands/${key}`" class="show-all"> See all> </router-link>

                  <div class="list-brand-logo">
                    <div v-for="(brand, key) in value" :key="key" class="column-brand-logo">
                      <router-link
                        :key="key"
                        :to="`/brand/${brand.my_soco_sql_id}/${$options.filters.slug(brand.name)}`"
                        class="brand-logo"
                      >
                        <figure :title="brand.name">
                          <template v-if="brand.logo">
                            <img
                              :src="mainImage(brand.logo)"
                              alt="SOCO"
                              onerror="this.src='/assets/img/default_img_brand.svg'"
                              class="brand-logo__img"
                            />
                          </template>
                          <template v-else>
                            <img src="/assets/img/default_img_brand.svg" class="brand-logo__img" alt="SOCO" />
                          </template>
                        </figure>
                      </router-link>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <h4>No Brands</h4>
                </div>
              </div>
              <div v-else>
                <div v-for="i in 4" :key="`${i}_GMP_1`" style="margin-bottom: 30px">
                  <GFMP
                    :key="`${i}_GMP_1`"
                    :styles="{
                      minHeight: '20px',
                      marginBottom: '16px',
                      width: '100%',
                    }"
                  />
                  <GFMP
                    :key="`${i}_GMP_2`"
                    :styles="{
                      minHeight: '20px',
                      marginBottom: '16px',
                      width: '90%',
                    }"
                  />
                  <GFMP
                    :key="`${i}_GMP_3`"
                    :styles="{
                      minHeight: '20px',
                      marginBottom: '16px',
                      width: '80%',
                    }"
                  />
                  <GFMP
                    :key="`${i}_GMP_4`"
                    :styles="{
                      minHeight: '600px',
                      marginBottom: '16px',
                      width: '100%',
                    }"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <popularBrands />
          <AddThoughts
            button-text="Write Review"
            button-redirect-url="/review/add"
            copywriting="Ingin berkontribusi menambah review dengan konten yang menarik?"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import popularBrands from '@/components/sidebar/popularBrands';
import AddThoughts from '@/components/global/add-thoughts/add-thoughts';

export default {
  name: 'my-brand',
  components: {
    popularBrands,
    AddThoughts,
  },
  data() {
    return {
      isFinishLoadingAllBrand: false,
      allBrand: [],
      keyword: '',
      selectedLetter: 'A',
    };
  },
  computed: {
    screen() {
      return this.$store.state.screen;
    },
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
  },
  watch: {
    'screen.isDesktop'() {
      this.redirectToHome();
    },
  },
  created() {
    this.redirectToHome();
    this.getBrands();
  },
  methods: {
    getBrands() {
      this.isFinishLoadingAllBrand = false;
      this.$MS_SOCO_PUBLIC_API_URL
        .get('/brands/letter', {
          params: {
            section: 'getBrands',
            fields: 'my_soco_sql_id name logo',
            limit: 100,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            this.allBrand = response.data.data;
          } else {
            this.allBrand = [];
          }

          this.isFinishLoadingAllBrand = true;
        })
        .catch((err) => {
          console.log(err);
          this.allBrand = [];
          this.isFinishLoadingAllBrand = true;
        });
    },
    redirectToHome() {
      if (!this.screen.isDesktop) {
        this.$router.push('/');
      }
    },
    searchQuery(e) {
      if (this.keyword) {
        this.$MS_SOCO_PUBLIC_API_URL
          .get('/brands', {
            params: {
              fields: 'my_soco_sql_id name logo',
              limit: 10,
              filter: {
                name: { $regex: '^' + this.keyword, $options: 'i' },
              },
            },
          })
          .then((res) => {
            const data = res.data.data;
            this.allBrand = {};
            this.allBrand[this.keyword[0]] = data;
          });
      } else {
        this.getBrands();
      }
    },
    toLetter(letter) {
      this.selectedLetter = letter;
      const topPos = document.getElementById('brand-letter-' + letter).offsetTop;
      const containerOffset = document.getElementById('brand-value').offsetTop;
      document.getElementById('brand-value').scrollTop = topPos - containerOffset;
    },
    mainImage(src) {
      return this.$options.filters.imageCdn({
        config: this.isDesktop ? 'w=150' : 'w=144',
        image: src,
      });
    },
  },
};
</script>
